<template>
  <div class="full-height d-flex align-center">
    <v-alert class="mt-3 col-12" color="third">
      <div class="mb-2 white--text">
        <strong>Ups,</strong>
        {{ message }}<br>
      </div>
      <v-btn v-if="showReturnButton" outlined class="mr-2" color="white" @click="homepage">
        <v-icon>mdi-home</v-icon>
        <span class="ml-1">Retour à l'accueil</span>
      </v-btn>
    </v-alert>
  </div>
</template>

<script>
import { homepage } from '../../helpers/utils';

export default {
  props: {
    message: {
      type: String,
      default: null
    },
    showReturnButton: {
      type: Boolean,
      default: true
    }
  },
  setup () {
    return { homepage };
  }
};
</script>
